import React, { useState, useEffect } from 'react';
import { Notification, Card } from "rbx";
import ParkingService from '../../../services/parking';
import GeocodeService from '../../../services/geocoder';
import AppService from '../../../services/app';
import { placaMask, latMask, lngMask, unMask } from '../../../commons/masks';
import Controls from '../../components/Controls/Controls';
import Autocomplete from '../../components/Autocomplete';

const styleHr = {
  backgroundColor: 'transparent', 
  borderColor: 'rgb(221, 221, 221)', 
  borderStyle: 'dashed', 
  borderWidth: '1px 0px 0px', 
  margin: '15px 0'
};

const AppStartParkingForm = (props) => {
  const { setMessage, goToMenu } = props;
  const app = JSON.parse(sessionStorage.getItem('app'));

  const [licensePlate, setLicensePlate] = useState('');
  const [description, setDescription] = useState('');
  const [cityName, setCityName] = useState('');
  const [ruleId, setRuleId] = useState('');
  const [rules, setRules] = useState([]);
  const [latitude, setLatitude] = useState('');
  const [longitude, setLongitude] = useState('');

  const [status, setStatus] = useState('');
  const [stateButton, setStateButton] = useState('');

  useEffect(()=>{
    fetchRules();
  }, []);

  const fetchRules = async () => {
    try {
      const response = await ParkingService.rules({ cityName: 'FORTALEZA' });
      const rulesTemp = response.data.rules;
      let rulesSort = [];
      rulesSort.push({ value: rulesTemp[rulesTemp.length-1]._id, description: rulesTemp[rulesTemp.length-1].name });
      rulesTemp.forEach((rule, index) => {
        if (index !== rulesTemp.length-1)
          rulesSort.push({ value: rule._id, description: rule.name });
      });
      setRules([...rulesSort]);
    } catch(e) {
      console.log(e, ' - ', e.message);
    }
  }

  const handleSubmit = async (evt) => {
    evt.preventDefault();
    setStateButton("loading");
    try {
      let parking = {
        cpf_cnpj: app.cpf_cnpj,
        cityName: cityName,
        description: description,
        licensePlate: unMask(licensePlate),
        ruleId: ruleId,
        lat: latitude,
        lng: longitude,
        renewed: false,
        IMEI_UDID: process.env.REACT_APP_IMEI_DEFAULT,
        type: 1 // 1: 'UNLOCK', 2: 'ACTIVATION', 3: 'UNLOCK_ACTIVATION', 4: 'CANCELLATION'
      }
      const response = await ParkingService.parking(parking);
      await AppService.findByCpf(app.cpf_cnpj);
      await AppService.vehiclesParked(app.cpf_cnpj, true);
      setMessage(['success', response.data.message]);
      goToMenu();
    } catch(e) {
      setStatus(['danger', `${e.response.status}: ${e.response.data.errors}`]);
    }
    setStateButton('');
  }

  const findAddressByGoogle = async (evt) => {
    evt.preventDefault();
    try {
      const response = await GeocodeService.fromAddress(`${description}, FORTALEZA, CE`);

      const addressComponents = response.results[0].address_components;
      if (addressComponents.length > 6)
        setCityName(addressComponents[3].long_name.toUpperCase());
      else if (addressComponents.length <= 4)
        setCityName(addressComponents[1].long_name.toUpperCase());
      else
        setCityName(addressComponents[2].long_name.toUpperCase());

      setDescription(response.results[0].formatted_address.toUpperCase());

      const { lat, lng } = response.results[0].geometry.location;
      setLatitude(lat);
      setLongitude(lng);

      const response2 = await ParkingService.rules({ cityName: 'FORTALEZA', lat: lat, lng: lng });
      if (response2.data.region_rule)
        setRuleId(response2.data.region_rule._id);
      else
        setRuleId('');
    } catch(error) {
      setStatus(['danger', `${error}`]);
      console.error(error);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <Card>
        <Card.Header>
          <Card.Header.Title>Estacionar um veículo</Card.Header.Title>
        </Card.Header>
        <Card.Content>
          { status!=='' && <Notification color={status[0]}>{status[1]}</Notification> }
          <Autocomplete
            suggestions={app.vehicles.map((licensePlate)=>placaMask(licensePlate))}
            label="Placa do veículo"
            name="licensePlate"
            placeholder="ABC-1234"
            value={licensePlate}
            setValue={value => setLicensePlate( placaMask(value) )}
            focus={true}
            required
          />
          <hr style={ styleHr }/>
          <Controls.TextFieldWithSearch 
            label="Descrição do local"
            name="description"
            placeholder='Pesquise no Google Maps'
            value={description}
            onChange={e => setDescription(e.target.value.toUpperCase())}
            onClick={findAddressByGoogle}
            required
          />
          <Controls.TextField 
            label="Município"
            name="cityName"
            placeholder='FORTALEZA'
            value={cityName}
            onChange={e => setCityName(e.target.value.toUpperCase())}
            required
          />
          <Controls.TextField 
            label="Latitude"
            name="latitude"
            placeholder='-3.7337243'
            value={latitude}
            onChange={e => setLatitude( latMask(e.target.value) )}
            required
          />
          <Controls.TextField 
            label="Longitude"
            name="longitude"
            placeholder='-38.5201733'
            value={longitude}
            onChange={e => setLongitude( lngMask(e.target.value) )}
            required
          />
          <Controls.SelectField
            label="Regra"
            name="ruleId"
            value={ruleId}
            onChange={e => setRuleId(e.target.value)}
            options={rules}
            required
          />
          <Controls.ActionButtons
            linkName="Cancelar" 
            handleClickBack={goToMenu} 
            buttonState={stateButton} 
            buttonName='Estacionar'
          />
        </Card.Content>
      </Card>
    </form>
  )

}

export default AppStartParkingForm;
